import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { HashRouter as Router } from 'react-router-dom'
import { Switch, Route } from 'react-router'

import { getQuery, WX, setLoginToken } from '../public'
import Message from '../public/components/Message'
import NoMatch404 from '../public/components/Layout/NoMatch404'
import OrderingPlan from './Weixin/OrderingPlan'
import OrderingDetail from './Weixin/OrderingDetail'
import MyTask from './Weixin/MyTask'
import MySignedTask from './Weixin/MySignedTask'
import MySignedApplyTask from './Weixin/MySignedApplyTask'
import DetailTask from './Weixin/DetailTask'
import ShowFile from './Weixin/ShowFile'
import ForgetSwipeCardApply from './Weixin/ForgetSwipeCardApply'
import OverTimeApply from './Weixin/OverTimeApply'
import OutApply from './Weixin/OutApply'
import LeaveCancelApply from './Weixin/LeaveCancelApply'
import AdvanceApply from './Weixin/AdvanceApply'
import ExpenseTypeSelect from './Weixin/ExpenseTypeSelect'
import ExpenseApply from './Weixin/ExpenseApply'
import RequisitionApply from './Weixin/RequisitionApply'
import PurchaseApply from './Weixin/PurchaseApply'
import FlowRecordTask from './Weixin/FlowRecordTask'
import FlowRecordDetail from './Weixin/FlowRecordDetail'
import Form from 'Tyan/public/components/Form/Form'
import MessageForm from 'Tyan/public/components/FormMessage'
import AdvanceTask from './Weixin/AdvanceTask'
import ExpenseTask from './Weixin/ExpenseTask'
import PurchaseTask from './Weixin/PurchaseTask'
import RequisitionTask from './Weixin/RequisitionTask'
// const OrderingPlan = lazy(() => import(/* webpackChunkName: "OrderingPlan" */ './Weixin/OrderingPlan'))
// const OrderingDetail = lazy(() => import(/* webpackChunkName: "OrderingDetail" */ './Weixin/OrderingDetail'))

import PersonnelApplication from './Weixin/PersonnelApplication'
import AdvanceApplication from './Weixin/AdvanceApplication'
import ExpenseApplication from './Weixin/ExpenseApplication'
import LeaveApplication from './Weixin/LeaveApplication'
import AdministrativeApproval from './Weixin/AdministrativeApproval'

import DeductionItemConfirm from './Weixin/DeductionItemConfirm'
import DeductionItemConfirmDetail from './Weixin/DeductionItemConfirmDetail'

import DeductionItemDispose from './Weixin/DeductionItemDispose'
import DeductionItemDisposeDetail from './Weixin/DeductionItemDisposeDetail'

class WeixinLayout extends React.Component {
	state = {
		userName: null,
		loadJSSDK: false,
		// loadJSSDK: true,
		errorMessage: null,
	}
	componentDidMount() {
		const code = /* 'WXXDATEQD3654WEF2S.DF16WE56.21F11211' */getQuery(location.search, 'code')
		Tyan.doPostEvent('GetCodeInfo', {
			data: { code },
			onSuccess: () => {
				Tyan.doPostEvent('LoginByWeiXin', {
					data: { code },
					onFailure: ({ errorMessage }) => {
						this.setState({ errorMessage: '登录错误: ' + errorMessage })
					},
					onSuccess: ({ userName, token }) => {
						setLoginToken(token)
						this.setState({ userName })
						// 测试
						Tyan.doPostEvent('GetJSSDKSignatureInfo', {
							data: { url: location.origin + location.pathname + location.search },
							onFailure: ({ errorMessage }) => {
								this.setState({ errorMessage: '获取签名错误: ' + errorMessage })
							},
							onSuccess: ({ appId, timestamp, nonceStr, signature }) => {
								WX.config({
									beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
									debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
									appId, // 必填，企业微信的corpID
									timestamp, // 必填，生成签名的时间戳
									nonceStr, // 必填，生成签名的随机串
									signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
									jsApiList: ['chooseImage', 'uploadImage', 'downloadImage', 'scanQRCode', 'getLocation', 'getLocalImgData', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
								}, () => {
									//  alert('wx.ready')
									this.setState({ loadJSSDK: true })
								}, (res) => {
									this.setState({ errorMessage: 'JSSDK注册错误: ' + JSON.stringify(res) })
									//  alert(JSON.stringify(res))
								})
							}
						})
						// 测试
					}
				})
			},
			onFailure: ({ errorMessage }) => {
				this.setState({ errorMessage: '登录失败: ' + errorMessage })
			}
		})
	}
	render() {
		const { loadJSSDK, errorMessage, userName } = this.state
		if (errorMessage) {
			return <Message text="数据加载失败" subtext={errorMessage} />
		} else if (userName && loadJSSDK) {
			return (
				<Router>
					<Switch>

						{/* <Route exact path="/QYWX/MySignedTask" component={MySignedTask} /> */}
						{/* <Route exact path="/QYWX/MySignedApplyTask" component={MySignedApplyTask} /> */}
						<Route exact path="/QYWX/DetailTask/:title/:type/:id" component={DetailTask} />
						<Route exact path="/QYWX/ShowFile/:path/:ext" component={ShowFile} />
						<Route exact path="/QYWX/SelectPurchaseOrderNoDiv/:id" render={props => <SelectPurchaseOrderNoDiv {...props} showBody={Form} showMessage={MessageForm} />} />
						{/* <Route exact path="/QYWX/FlowRecordTask/:type" component={FlowRecordTask} /> */}
						{/* <Route exact path="/QYWX/ExpenseTask" component={ExpenseTask} />
						<Route exact path="/QYWX/AdvanceTask" component={AdvanceTask} /> */}
						{/* <Route exact path="/QYWX/PurchaseTask" component={PurchaseTask} />
						<Route exact path="/QYWX/RequisitionTask" component={RequisitionTask} /> */}

						{/* 订餐 */}
						<Route exact path="/QYWX/OrderingPlan" component={OrderingPlan} />
						<Route exact path="/QYWX/OrderingDetail/:date" component={OrderingDetail} />
						{/* 人事申请 */}
						<Route exact path="/QYWX/PersonnelApplication" component={PersonnelApplication} />
						<Route exact path="/QYWX/FlowRecordDetail/:id/:processId/:status" render={props => <FlowRecordDetail {...props} showBody={Form} />} />
						{/* 加扣项确认 */}
						<Route exact path="/QYWX/DeductionItemConfirm" component={DeductionItemConfirm} />
						<Route exact path="/QYWX/DeductionItemConfirmDetail/:id" render={props => <DeductionItemConfirmDetail {...props} showBody={Form} showMessage={MessageForm} />} />
						{/* 加扣项处理 */}
						<Route exact path="/QYWX/DeductionItemDispose" component={DeductionItemDispose} />
						<Route exact path="/QYWX/DeductionItemDisposeDetail/:id" render={props => <DeductionItemDisposeDetail {...props} showBody={Form} showMessage={MessageForm} />} />
						{/* 预支单申请 */}
						<Route exact path="/QYWX/AdvanceApplication" component={AdvanceApplication} />
						<Route exact path="/QYWX/AdvanceApply/:id" render={props => <AdvanceApply {...props} showBody={Form} showMessage={MessageForm} />} />
						{/* 报支单申请 */}
						<Route exact path="/QYWX/ExpenseApplication" component={ExpenseApplication} />
						<Route exact path="/QYWX/ExpenseApply/:id/:expenseName" render={props => <ExpenseApply {...props} showBody={Form} showMessage={MessageForm} />} />
						<Route exact path="/QYWX/ExpenseTypeSelect/:id" render={props => <ExpenseTypeSelect {...props} showBody={Form} showMessage={MessageForm} />} />
						{/* 请假销假申请 */}
						<Route exact path="/QYWX/LeaveApplication" component={LeaveApplication} />
						<Route exact path="/QYWX/OutApply/:id" render={props => <OutApply {...props} showBody={Form} showMessage={MessageForm} />} />
						<Route exact path="/QYWX/LeaveCancelApply/:id" render={props => <LeaveCancelApply {...props} showBody={Form} showMessage={MessageForm} />} />
						{/* 行政类签核 */}
						<Route exact path="/QYWX/AdministrativeApproval" component={AdministrativeApproval} />
						<Route exact path="/QYWX/ForgetSwipeCardApply/:id" render={props => <ForgetSwipeCardApply {...props} showBody={Form} showMessage={MessageForm} />} />
						<Route exact path="/QYWX/OverTimeApply/:id" render={props => <OverTimeApply {...props} showBody={Form} showMessage={MessageForm} />} />
						<Route exact path="/QYWX/RequisitionApply/:id" render={props => <RequisitionApply {...props} showBody={Form} showMessage={MessageForm} />} />
						<Route exact path="/QYWX/PurchaseApply/:id" render={props => <PurchaseApply {...props} showBody={Form} showMessage={MessageForm} />} />
						{/* 工程业务类签核 */}
						<Route exact path="/QYWX/EngineeringBusinessApproval" component={MyTask} />

						<Route component={NoMatch404} />
					</Switch>
				</Router>
			)
		} else if (!userName) {
			return <Message text="数据加载" subtext={'登录中...'} />
		} else if (!loadJSSDK) {
			return <Message text="数据加载" subtext={'注册JSSDK中...'} />
		} else {
			return <Message text="数据加载" subtext={'未知的状态...'} />
		}
	}
}

export default WeixinLayout
